import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Script from 'react-load-script';
import store from './store';

// Auth
import Login from './Pages/Auth/Login/Container';
import Register from './Pages/Auth/Register/Container';
import ForgotPassword from './Pages/Auth/ForgotPassword/Container';
import ResetPassword from './Pages/Auth/ResetPassword/Container';

//User MAnagement
import UserList from './Pages/UserManagement/UserList/Container';

// Residential Management
import CustomerList from "./Pages/ResidentialManagement/CustomerList/Container";
import CustomerDetail from "./Pages/ResidentialManagement/CustomerDetail/Container";
import LeadDetail from './Pages/ResidentialManagement/LeadDetail/Container';
import LeadQuoteService from './Pages/ResidentialManagement/LeadQuoteService/Container';
import DogInfo from "./Pages/ResidentialManagement/DogInfo/Container";
import AddCustomer from "./Pages/ResidentialManagement/AddCustomer/Container";

//Case management
import CaseManagement from "./Pages/CaseManagement/Container";

//Franchise Management
import FranchiseList from "./Pages/FranchiseManagement/List/Container";
import FranchiseDetails from "./Pages/FranchiseManagement/Details/Container";
import StripeReturn from "./Pages/Common/Component/stripe-return";
import RefreshUrl from "./Pages/Common/Container";

//Accounting
import AccountList from './Pages/Accounting/AccountList/Container'
import html from './Pages/AcccountHtml/html';
import Dashboard from './Pages/Dashboard/Container';
import Settings from './Pages/Settings/Container';
import Typo from './Pages/Typo/typo';

// Commercial Management
import Commercial from "./Pages/CommercialManagement/List/Container"
import AddProposal from "./Pages/CommercialManagement/AddQuote/Container"
import CommercialCustomerDetail from "./Pages/CommercialManagement/CustomerDetail/Container"
import CommercialProposalDetail from "./Pages/CommercialManagement/ProposalDetail/Container"

// import WeekSetup from './Pages/field-ops/week_setup'
import WeekSetupViewAllocation from './Pages/field-ops/week_setup_view_allocation'
import Demo from './Pages/field-ops/demo'

//Field Tech
import EODReport from './Pages/FieldTech/EODReport/Container';
import WeekSetup from './Pages/FieldTech/WeekSetup/Container';
import BulkReassign from './Pages/FieldTech/BulkReassign/Container';
import SchedulingErrors from './Pages/FieldTech/SchedulingErrors/Container';
import ViewByWorkOrder from './Pages/FieldTech/ViewByWorkOrder/Container';

//Reports
import ReportList from './Pages/Reports/ReportList/Container';
import ViewBreakdown from './Pages/Reports/Common/Container';
import Reports from './Pages/Reports/ReportCardList/Component/ReportCardList';

function App() {
  return (
    <Provider store={store}>
      <Script
        url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
        // onLoad={this.handleScriptLoad}
        onError={(e) => {
          console.log(e)
        }}
      />
      <BrowserRouter>
        <Switch>
          <Route path='/' component={Login} exact />
          <Route path='/register/:token' component={Register} />
          <Route path='/forgot-password' component={ForgotPassword} />
          <Route path='/reset-password/:token' component={ResetPassword} />
          <Route path='/dashboard' component={Dashboard} />
          <Route path='/settings' component={Settings} />
          <Route path='/residential/lead/new-service' component={LeadQuoteService} />
          <Route path='/residential/lead/detail' component={LeadDetail} />
          <Route path='/residential/detail' component={CustomerDetail} />
          <Route path='/residential/dog-info' component={DogInfo} />
          <Route path='/residential/new-customer' component={AddCustomer} />
          <Route path='/residential' component={CustomerList} />
          <Route path='/case-management' component={CaseManagement} />
          <Route path='/franchise' exact component={FranchiseList} />
          <Route path='/franchise/detail/' component={FranchiseDetails} />

          <Route path='/commercial/customer-detail' component={CommercialCustomerDetail} />
          <Route path='/commercial/proposal-detail' component={CommercialProposalDetail} />
          <Route path='/commercial/new-proposal' component={AddProposal} />
          <Route path='/commercial' component={Commercial} />

          <Route path='/account' exact component={AccountList} />

          <Route path='/user-list' component={UserList} />
          <Route path='/account_html' component={html} />
          <Route path='/typo' component={Typo} />
          {/* <Route path='/week_setup' component={WeekSetup} /> */}
          <Route path='/week_setup_view_allocation' component={WeekSetupViewAllocation} />
          <Route path='/demo' component={Demo} />
          <Route path='/stripe-return' component={StripeReturn} />
          <Route path='/refresh_url' component={RefreshUrl} />

          <Route path='/field_tech/eod_report' exact component={EODReport} />
          <Route path='/field_tech/week_setup' exact component={WeekSetup} />
          <Route path='/field_tech/bulk-reassign' exact component={BulkReassign} />
          <Route path="/field_tech/scheduling_errors" exact component={SchedulingErrors}/>
          <Route path="/field_tech/view-by-work-order" exact component={ViewByWorkOrder}/>

          <Route path='/reports' exact component={Reports} />
          <Route path='/reports/report' exact component={ReportList} />
          <Route path='/reports/royalty-reports-viewbreakdown' exact component={ViewBreakdown} />
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
